import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

import { SUPABASE } from '../../tokens/supabase.token';

/**
 * Adds an `Authorization` header to requests to the API.
 *
 * @param apiSegment - The starting segment of the API URL. Only requests starting with this segment will be intercepted
 */
export const authInterceptor: (apiSegment?: string) => HttpInterceptorFn = (apiSegment?: string) => (req, next) => {
    if (apiSegment && !req.url.startsWith(apiSegment)) {
        return next(req);
    }

    const supabase = inject(SUPABASE);

    return fromPromise(supabase.auth.getSession()).pipe(
        switchMap(({ data: { session } }) => {
            if (!session?.access_token) {
                return next(req);
            }

            return next(req.clone({
                headers: req.headers.set('Authorization', `Bearer ${session?.access_token}`)
            }));
        })
    );
};
